import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { slate70 } from '@zocdoc-mezzanine/foundations-colors';
import { Button } from '@zocdoc-frontend-common/components-button';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';

import { MODAL_STRINGS } from './constants';

const ElementOrStringProp = PropTypes.oneOf([
    PropTypes.element,
    PropTypes.string,
]);
export class ModalContentView extends Component {
    static propTypes = {
        descriptionText: ElementOrStringProp,
        headerText: ElementOrStringProp,
        onClickPrimaryButton: PropTypes.func.isRequired,
        onClickSecondaryButton: PropTypes.func,
        primaryButtonText: ElementOrStringProp,
        secondaryButtonText: ElementOrStringProp,
        sendMetric: PropTypes.func,
    };

    render() {
        const {
            headerText,
            descriptionText,
            primaryButtonText,
            dataTest = 'no-data-test',
        } = this.props;

        const shouldShowWiderPrimaryButton =
            primaryButtonText &&
            primaryButtonText.length &&
            primaryButtonText.length > 15
                ? true
                : false;
        return (
            <div data-test={dataTest}>
                <Header data-test="header-text">{headerText}</Header>

                <Description data-test="description-text">
                    {descriptionText}
                </Description>

                <PrimaryButton
                    data-test="primary-button"
                    data-uem-id="modal-primary-button"
                    onClick={this.handleClickPrimaryCTA}
                    variation="btn-primary"
                    shouldShowWiderPrimaryButton={shouldShowWiderPrimaryButton}
                >
                    {primaryButtonText || MODAL_STRINGS.Ok}
                </PrimaryButton>

                {this.renderSecondaryButton(shouldShowWiderPrimaryButton)}
            </div>
        );
    }

    handleClickPrimaryCTA = () => {
        const { onClickPrimaryButton, sendMetric } = this.props;

        sendMetric({
            action: 'Click view upcoming appointments',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
            component: 'Vaccine Fraud Modal',
            element: 'View upcoming appointments button',
        });
        onClickPrimaryButton();
    };

    handleClickSecondaryCTA = () => {
        const { onClickSecondaryButton, sendMetric } = this.props;

        sendMetric({
            action: 'Click cancel',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
            component: 'Vaccine Fraud Modal',
            element: 'cancel button',
        });
        onClickSecondaryButton();
    };

    renderSecondaryButton(shouldShowWiderPrimaryButton) {
        const { onClickSecondaryButton, secondaryButtonText } = this.props;

        if (onClickSecondaryButton) {
            return (
                <SecondaryButton
                    data-test="secondary-button"
                    onClick={this.handleClickSecondaryCTA}
                    variation="btn-secondary"
                    shouldShowWiderPrimaryButton={shouldShowWiderPrimaryButton}
                >
                    {secondaryButtonText || MODAL_STRINGS.Cancel}
                </SecondaryButton>
            );
        }
    }
}

const Header = styled.div`
    font: 15px/24px ${FontFamily.SharpSansBold};
    margin-bottom: 4px;
`;

const Description = styled.div`
    color: ${slate70};
    font: 14px/24px ${FontFamily.KievitSlabBook};
    margin-bottom: 32px;

    ${breakpoint.xsmall} {
        margin-bottom: 80px;
    }
`;

const PrimaryButton = styled(Button)`
    box-sizing: border-box;
    margin-bottom: 8px;
    width: 100%;

    ${breakpoint.small} {
        float: left;
        width: ${p =>
            p.shouldShowWiderPrimaryButton
                ? 'calc(55% - 8px)'
                : 'calc(50% - 8px)'};
        margin-right: 8px;
    }

    ${breakpoint.medium} {
        width: calc(50% - 8px);
    }
`;

const SecondaryButton = styled(Button)`
    box-sizing: border-box;
    width: 100%;

    ${breakpoint.small} {
        float: right;
        width: ${p =>
            p.shouldShowWiderPrimaryButton
                ? 'calc(45% - 8px)'
                : 'calc(50% - 8px)'};
        margin-left: 8px;
    }

    ${breakpoint.medium} {
        width: calc(50% - 8px);
    }
`;
